import { Button } from '@/components/atoms/button'
import { ButtonSizes, ButtonVariants } from '@/types/enums'
import { SearchIcon } from '@chakra-ui/icons'
import { chakra, Input, InputGroup, InputRightElement } from '@chakra-ui/react'
import { ButtonTypes, ComponentProps, TrackEvent } from '@/baseComponents'
import { useState, useEffect } from 'react'

export interface SearchBarProps extends ComponentProps {
  searchQuery?: string
  disableGroupHover?: boolean
  handleSearch?: () => void
  searchInputRef?: React.RefObject<HTMLInputElement>
  trackEvent: trackProps
  placeHolder?: string
}
export interface trackProps {
  interactionType?: string
  blockName: string
  searchQuery: string
  totalItems: number
}

export default chakra(SearchBar)
function SearchBar({
  searchQuery = '',
  disableGroupHover,
  theme = 'brand',
  searchInputRef,
  handleSearch,
  trackEvent,
  placeHolder = 'Search',
  ...props
}: SearchBarProps) {
  const [inputValue, setInputValue] = useState(searchQuery)

  // Update the internal state when searchQuery prop changes
  useEffect(() => {
    setInputValue(searchQuery)
  }, [searchQuery])

  return (
    <InputGroup width={'full'} display='flex' alignItems='center' {...props}>
      <Input
        ref={searchInputRef}
        borderRadius={'0.375rem'}
        px='1.25rem'
        py='1.25rem'
        h='3.5rem'
        type='text'
        fontWeight={300}
        color={`${theme}.aubergine`}
        fontSize='1rem'
        value={inputValue}
        onChange={(e) => {
          setInputValue(e.target.value)
          if (searchInputRef && searchInputRef.current) {
            searchInputRef.current.value = e.target.value
          }
        }}
        placeholder={placeHolder}
        backgroundColor={`${theme}.grey`}
        borderColor='transparent'
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            handleSearch?.()
            TrackEvent('search_term', {
              interactionType: trackEvent.interactionType ?? 'Search on enter',
              blockName: trackEvent?.blockName,
              searchQuery: trackEvent?.searchQuery,
              totalItems: trackEvent?.totalItems,
            })
          }
        }}
        _placeholder={{
          color: `${theme}.dark`,
          fontWeight: 300,
        }}
      />

      <InputRightElement width='fit-content' height={'full'} pr='1.25rem'>
        <Button
          disableGroupHover={disableGroupHover}
          buttonSize={ButtonSizes.Small}
          buttonType={ButtonTypes.IconOnly}
          buttonVariant={ButtonVariants.Secondary}
          icon={<SearchIcon />}
          text='Search'
          onClick={() => {
            handleSearch?.()
            TrackEvent('search_term', {
              interactionType: trackEvent.interactionType ?? 'Search on click',
              blockName: trackEvent?.blockName,
              searchQuery: trackEvent?.searchQuery,
              totalItems: trackEvent?.totalItems,
            })
          }}
        />
      </InputRightElement>
    </InputGroup>
  )
}
